import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconVoD = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
        <path d='M32 27.667l-6.467-4.533c0 2.267-1.8 4.067-4.067 4.067h-17.4c-2.267 0-4.067-1.8-4.067-4.067v-14.733c0-2.267 1.8-4.067 4.067-4.067h17.467c2.267 0 4.067 1.8 4.067 4.067v0.667l6.4-4.6v23.2zM4.067 6c-1.333 0-2.4 1.067-2.4 2.4v14.8c0 1.333 1.067 2.4 2.4 2.4h17.467c1.333 0 2.4-1.067 2.4-2.4v-3.267l6.467 4.533v-16.667l-6.467 4.533v-3.933c0-1.333-1.067-2.4-2.4-2.4h-17.467z'/>
    </SvgIcon>
  );
};

IconVoD.displayName = 'IconVoD';
IconVoD.muiName = 'SvgIcon';

export default IconVoD;



// WEBPACK FOOTER //
// ./src/components/Icons/IconVoD.js